import React from 'react';

import AdminCommentListContainer from '@src/components/comment/AdminCommentListContainer';

const AdminCommentPage = () => <AdminCommentListContainer />;

export default AdminCommentPage;
